import Vue from 'vue'
import App from './App.vue'
import MultiCarousel from './components/MultiCarousel.vue'
import router from './router'

Vue.config.productionTip = false
Vue.component('MultiCarousel', MultiCarousel)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
